export default __webpack_public_path__ + "c6cbf93.png";